import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "./TourMain.css";

import "../../styles/font.css";
import { TopMenu } from '../../component/TopMenu';
import { TourDetail } from "./components/TourDetail";
import { TourContainer } from './components/TourContainer';
import { TourFooter } from './components/TourFooter';
import { API_CONFIG } from '../../config/api';

const artlog_ip = process.env.REACT_APP_ARTLOG_IP;

export const TourMain = () => {

  function getCookie(name) {
    let cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split('=');
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  const navigate = useNavigate();
  const [searchKeyword, setSearchKeyword] = useState('');

  // 일반 사용자, 예술가 계정으로 로그인 가능. 대상마다 다르게 렌더링
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null); // 'user' or 'artist' or null
  const [userName, setUserName] = useState("");

  // 전국박물관미술관 표준데이터를 통해 얻은 내용
  const [museumData, setMuseumData] = useState([]);
  const [selectedMuseumData, setSelectedMuseumData] = useState(null);

  // Yournest에 등록된 공방 정보 (작가 정보 아님)
  const [tourData, setTourData] = useState([]);
  const [selectedTourData, setSelectedTourData] = useState(null);

  // Youenest 관리자가 등록한 POI 데이터
  const [poiData, setPoiData] = useState([]);
  const [selectedPoiData, setSelectedPoiData] = useState(null);
  
  const [map, setMap] = useState(null); // 카카오맵 인스턴스를 저장, 관리하는 데 사용
  const [pageNum, setPageNum] = useState(0); // 박물관 API 호출을 위해 사용되는 페이지 번호

  // 초기 지도 화면: 파주 어딘가로 설정
  const [userPosition, setUserPosition] = useState({ lat: 37.8075, lng: 126.7797 });
  const [showPreview, setShowPreview] = useState(true); // 지도 위에 덮어쓰는 미리보기 이미지

  // API 연동. 작가 기록 데이터 가져오기
  const [artistRecords, setArtistRecords] = useState([]);

  const gotoMain = () => {
    navigate('/');
  }
  const goToStudioTour = () => {
    navigate('/studio-tour');
  }
  const handleLogout = () => {
    // 일반 사용자 관련 모든 쿠키 삭제
    document.cookie = "yournest_u_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";

    // 작가 관련 모든 쿠키 삭제
    document.cookie = "yournest_a_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_profile=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_company=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_description=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_type=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_address=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lat=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lng=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    
    setIsAuthenticated(false);
    setUserType(null);
    setUserName("");
    alert("로그아웃 되었습니다");
  };

  // OpenAPI - 전국박물관미술관표준데이터 가져오기
  const fetchMuseumData = async (pageNum) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/museum_data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ pageNum })
      });
      
      if (!response.ok) {
        throw new Error('API 호출 실패');
      }
      const data = await response.json();

      if (data.response && data.response.header) {
        const resultCode = data.response.header.resultCode;

        if (resultCode === "03") { // API에 더 이상 데이터가 없을 때 resultCode가 "03"
          console.log('더 이상 데이터가 없습니다.');
          return;
        }

        if (resultCode === "00" && data.response.body && data.response.body.items) {
          console.log('[fetchMuseumData] Data Fetched: ', pageNum);
          setMuseumData(prevMuseumData => [...prevMuseumData, ...data.response.body.items]);
          setPageNum(prevPageNum => prevPageNum + 1);
        }
      }
    } catch (error) {
      console.error('데이터 가져오기 실패:', error);
      setMuseumData([]);
    }
  };

  // 예술가가 등록한 아틀리에 정보 가져오기
  // id, artist_id, tour_name, tour_profile, tour_hashtag, tour_description, tour_location, tour_location_do, tour_location_si, tour_location_lat, tour_location_lng, tour_type, tour_price, tour_open_days, tour_open_time, tour_close_time, tour_break_time, tour_max_per_time
  const fetchTourData = async () => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/get_tour_overview`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('[fetchTourData] response is not ok');
      }
      const data = await response.json();
      if (data.isSuccess) {
        setTourData(data.tours);
        console.log("[fetchTourData] Success");
        console.log(tourData);
      }
    } catch (error) {
      console.error('[fetchTourData] Error:', error);
    }
  };

  // POI 데이터 가져오기
  const fetchPoiData = async () => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/admin_get_poi`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('[fetchPoiData] response is not ok');
      }
      const data = await response.json();
      if (data.isSuccess) {
        setPoiData(data.pois);
        console.log("[fetchPoiData] Success");
      }
    } catch (error) {
      console.error('[fetchPoiData] Error:', error);
    }
  };

  // 작가 기록 데이터 가져오기
  const fetchArtistRecords = async (artistId) => {
    try {
      // 1. 먼저 서버에서 artlog_token 가져오기
      console.log('[fetchArtistRecords] artistId: ', artistId);
      const tokenResponse = await fetch(`${API_CONFIG.MAIN}/get_artist_token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ artist_id: artistId }),
      });
  
      if (!tokenResponse.ok) {
        throw new Error('Failed to get artist token');
      }
  
      const tokenData = await tokenResponse.json();
      
      if (!tokenData.isSuccess) {
        throw new Error(tokenData.message);
      }
  
      // 2. artlog_token으로 작가 기록 가져오기
      const recordResponse = await fetch(`${artlog_ip}:3541/api/get_artist_record`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          auth_token: tokenData.artlog_token
        })
      });
  
      if (!recordResponse.ok) {
        throw new Error('Failed to fetch artist records');
      }
  
      const recordData = await recordResponse.json();
      
      if (recordData.isSuccess) {
        setArtistRecords(recordData.records);
      } else {
        setArtistRecords([]);
      }
    } catch (error) {
      console.error('Error fetching artist records:', error);
      setArtistRecords([]);
    }
  };

  // 컴포넌트 최상단에 추가
  const formatPhoneNumber = (phone) => {
    if (!phone) return '-';
    // 숫자만 추출
    const numbers = phone.replace(/[^0-9]/g, '');
    
    // 길이에 따른 포맷팅
    if (numbers.length === 11) {
      // 휴대폰 번호 (01012345678 -> 010-1234-5678)
      return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    } else if (numbers.length === 10) {
      // 지역 번호 (0212345678 -> 02-1234-5678)
      return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
    } else if (numbers.length === 9) {
      // 지역 번호 (021234567 -> 02-123-4567)
      return numbers.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    return phone; // 기타 형식은 원본 반환
  };

  const formatOpenDays = (openDays) => {
    if (!openDays) return '-';
    
    const days = openDays.split(',').map(Number);
    
    // 연중무휴 체크
    if (days.length === 7) {
      return '연중무휴';
    }
    
    // 요일 매핑
    const dayNames = ['일', '월', '화', '수', '목', '금', '토'];
    const selectedDays = days.map(day => dayNames[day]);
    
    // 연속된 요일 체크
    if (days.length > 2) {
      const isConsecutive = days.every((day, index) => {
        if (index === 0) return true;
        return day === days[index - 1] + 1;
      });
      
      if (isConsecutive) {
        return `매주 ${selectedDays[0]}~${selectedDays[selectedDays.length - 1]}`;
      }
    }
    
    return `매주 ${selectedDays.join(', ')}`;
  };

  const initMap = () => {
    console.log('[initMap] function occurred');
    const mapContainer = document.getElementById('map');
    const mapOption = {
      center: new window.kakao.maps.LatLng(userPosition.lat, userPosition.lng), // 현재 위치로 지도 중심 설정
      level: 8,
    };
    const kakaoMap = new window.kakao.maps.Map(mapContainer, mapOption);
    setMap(kakaoMap);
  };

  let currentInfoWindow = null;

  const displayMarkers = () => {
    if (map && (museumData.length > 0 || tourData.length > 0 || poiData.length > 0)) {
      const currentBounds = map.getBounds();

      // 기존 마커 제거
      if (map.markers && map.markers.length > 0) {
        map.markers.forEach(marker => marker.setMap(null));
        map.markers = [];
      }
      const markers = [];

      // 박물관 마커 생성
      museumData.forEach(data => {
        const markerPosition = new window.kakao.maps.LatLng(
          parseFloat(data.latitude),
          parseFloat(data.longitude)
        );

        if (currentBounds.contain(markerPosition)) {
          const museumMarker = new window.kakao.maps.Marker({
            position: markerPosition,
            map: map,
            title: data.fcltyNm,
            image: new window.kakao.maps.MarkerImage(
              data.fcltyNm.includes('미술관') ? "/icons/map_icon_gallery.svg" : "/icons/map_icon_museum.svg",
              new window.kakao.maps.Size(20, 20),
              { offset: new window.kakao.maps.Point(10, 20) }
            )
          });

          const infowindow = new window.kakao.maps.InfoWindow({
            content: 
            `<div class="tour-map__icon-info">
              <div class="tour-map__icon-info-title">${data.fcltyNm}</div>
              <div class="tour-map__icon-info-address">${data.lnmadr}</div>
            </div>`,
          });

          let timer = null;

          window.kakao.maps.event.addListener(museumMarker, 'mouseover', () => {
            infowindow.open(map, museumMarker);
            timer = setTimeout(() => {
              infowindow.close();
            }, 3000);
          });

          window.kakao.maps.event.addListener(museumMarker, 'mouseout', () => {
            infowindow.close();
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
          });

          window.kakao.maps.event.addListener(museumMarker, 'click', () => {
            setSelectedMuseumData(data);
            setSelectedTourData(null); // 작가 선택 해제
          });

          markers.push(museumMarker);
        }
      });

      // 아틀리에 마커 생성
      tourData.forEach(data => {
        const markerPosition = new window.kakao.maps.LatLng(
          parseFloat(data.tour_location_lat),
          parseFloat(data.tour_location_lng)
        );

        if (currentBounds.contain(markerPosition)) {
          const tourMarker = new window.kakao.maps.Marker({
            position: markerPosition,
            map: map,
            title: data.tour_name,
            image: new window.kakao.maps.MarkerImage(
              "/icons/map_icon_artist.svg",
              new window.kakao.maps.Size(20, 20),
              { offset: new window.kakao.maps.Point(10, 20) }
            )
          });

          const infowindow = new window.kakao.maps.InfoWindow({
            content: 
            `<div class="tour-map__icon-info">
              <div class="tour-map__icon-info-title">${data.tour_name}</div>
              <div class="tour-map__icon-info-address">${data.tour_location}</div>
            </div>`,
          });

          let timer = null;

          window.kakao.maps.event.addListener(tourMarker, 'mouseover', () => {
            infowindow.open(map, tourMarker);
            timer = setTimeout(() => {
              infowindow.close();
            }, 3000);
          });

          window.kakao.maps.event.addListener(tourMarker, 'mouseout', () => {
            infowindow.close();
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
          });

          window.kakao.maps.event.addListener(tourMarker, 'click', () => {
            setSelectedTourData(data);
            setSelectedMuseumData(null); // 박물관 선택 해제
          });
          markers.push(tourMarker);
        }
      });

      // POI 마커 생성
      poiData.forEach(data => {
        const markerPosition = new window.kakao.maps.LatLng(
          parseFloat(data.tour_location_lat),
          parseFloat(data.tour_location_lng)
        );

        if (currentBounds.contain(markerPosition)) {
          const poiMarker = new window.kakao.maps.Marker({
            position: markerPosition,
            map: map,
            title: data.tour_name,
            image: new window.kakao.maps.MarkerImage(
              "/icons/map_icon_poi.svg",
              new window.kakao.maps.Size(20, 20),
              { offset: new window.kakao.maps.Point(10, 20) }
            )
          });

          const infowindow = new window.kakao.maps.InfoWindow({
            content: 
            `<div class="tour-map__icon-info" style="border: none;">
              <div class="tour-map__icon-info-title">${data.tour_name}</div>
              <div class="tour-map__icon-info-address">${data.tour_location}</div>
            </div>`,
          });

          let timer = null;

          window.kakao.maps.event.addListener(poiMarker, 'mouseover', () => {
            infowindow.open(map, poiMarker);
            timer = setTimeout(() => {
              infowindow.close();
            }, 3000);
          });

          window.kakao.maps.event.addListener(poiMarker, 'mouseout', () => {
            infowindow.close();
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
          });

          window.kakao.maps.event.addListener(poiMarker, 'click', () => {
            setSelectedPoiData(data);
            setSelectedMuseumData(null);
            setSelectedTourData(null);
          });

          markers.push(poiMarker);
        }
      });

      map.markers = markers;
    }
  };

  const handleImageClick = () => {
    const previewImage = document.querySelector('.tour-map__map-preview');
    if (previewImage) {
      previewImage.classList.add('fade-out'); // 부드럽게 사라지게 만들기
  
      // 0.5초 후 (애니메이션 시간 후) display: none 적용
      setTimeout(() => {
        setShowPreview(false);
      }, 2000);
    }
  };

  const moveToUserPosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserPosition({ lat: latitude, lng: longitude });

          // 지도를 유저의 현재 위치로 이동
          if (map) {
            const moveLatLon = new window.kakao.maps.LatLng(latitude, longitude);
            map.setCenter(moveLatLon);
            map.setLevel(5);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
        }
      );
    }
  };

  // 두 토큰을 다 가지고 있을 때 삭제
  useEffect(() => {
    const userToken = getCookie('yournest_u_auth_token');
    const artistToken = getCookie('yournest_a_auth_token');
    
    if (userToken && artistToken) {
      // 두 토큰이 모두 있는 경우 처리
      console.error("Multiple tokens detected");
      handleLogout(); // 모든 토큰 삭제
      navigate('/login');
      return;
    }
    
    if (userToken) {
      verifyUserToken(userToken);
    } else if (artistToken) {
      verifyArtistToken(artistToken);
    }
  }, []);

  // 사용자, 예술가 인증 로직
  useEffect(() => {
    const userToken = getCookie('yournest_u_auth_token');
    const artistToken = getCookie('yournest_a_auth_token');
    
    if (userToken) {
      verifyUserToken(userToken);
    } else if (artistToken) {
      verifyArtistToken(artistToken);
    }
  }, []);

  const verifyUserToken = async (token) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/verify_user_token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ auth_token: token }),
      });

      if (response.ok) {
        const data = await response.json();
        setIsAuthenticated(true);
        setUserType('user');
        setUserName(data.user_name);
      } else {
        setIsAuthenticated(false);
        setUserType(null);
      }
    } catch (error) {
      console.error('Token verification error:', error);
      setIsAuthenticated(false);
      setUserType(null);
    }
  };
  const verifyArtistToken = async (token) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/verify_artist_token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ auth_token: token }),
      });

      if (response.ok) {
        const data = await response.json();
        setIsAuthenticated(true);
        setUserType('artist');
        setUserName(data.artist_name);
      } else {
        setIsAuthenticated(false);
        setUserType(null);
      }
    } catch (error) {
      console.error('Token verification error:', error);
      setIsAuthenticated(false);
      setUserType(null);
    }
  };

  useEffect(() => {
    fetchMuseumData(pageNum);
  }, [pageNum]);

  useEffect(() => {
    if (map) {
      // 지도 레벨이 변경될 때마다 displayMarkers를 호출하여 마커 업데이트
      window.kakao.maps.event.addListener(map, 'zoom_changed', displayMarkers);
    }
  }, [map, museumData]);

  useEffect(() => {
    if (map) {
      displayMarkers(); // museumLocations가 변경될 때마다 마커 업데이트
    }
  }, [museumData, map]);

  useEffect(() => {
    if (window.kakao && window.kakao.maps) {
      initMap();
    } else {
      const script = document.createElement("script");
      script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=cdabbe0b4373d904f58d672d596b6630&libraries=services&autoload=false`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        window.kakao.maps.load(initMap);
      };
      document.head.appendChild(script);
    }
  }, []);

  useEffect(() => {
    fetchPoiData();
    fetchTourData();
  }, []);

  // const MuseumDetail = ({ data }) => (
  //   <>
  //     <div className="tour-detail__title-block">
  //       <div className="tour-detail__title-text">{data.fcltyNm || '-'}</div>
  //       <div className="tour-detail__title-tag">{data.fcltyNm.includes('미술관') ? '미술관' : '박물관'}</div>
  //     </div>
      
  //     <div className="tour-detail__info-text">정보</div>
      
  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_address.svg" />
  //       <div className="tour-detail__detail-text">{data.rdnmadr || '-'}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_phone.svg" />
  //       <div className="tour-detail__detail-text">{data.phoneNumber || '-'}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
  //       <div className="tour-detail__detail-text">
  //         평일 : {data.weekdayOperOpenHhmm || '-'}-{data.weekdayOperColseHhmm || '-'}<br/>
  //         공휴일 : {data.holidayOperOpenHhmm || '-'}-{data.holidayCloseOpenHhmm || '-'}<br/>
  //         휴관일 : {data.rstdeInfo || '-'}
  //       </div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_homepage.svg" />
  //       <div className="tour-detail__detail-text">{data.homepageUrl || '-'}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_price.svg" />
  //       <div className="tour-detail__detail-text">
  //         성인 : {data.adultChrge || '-'}원<br/>
  //         청소년 : {data.yngbgsChrge || '데이터가 없습니다'}원<br/>
  //         어린이 : {data.childChrge || '데이터가 없습니다'}원<br/>
  //         기타 : {data.etcChrgeInfo || '데이터가 없습니다'}
  //       </div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_introduce.svg" />
  //       <div className="tour-detail__detail-text">소개 : {data.fcltyIntrcn || '데이터가 없습니다'}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_type.svg" />
  //       <div className="tour-detail__detail-text">구분: {data.fcltyType || '데이터가 없습니다'}</div>
  //     </div>

  //     <div className="tour-detail__map-buttons">
  //       <a href={`https://map.kakao.com/link/map/${data.fcltyNm},${data.latitude},${data.longitude}`} target="_blank" rel="noopener noreferrer">
  //         <img className="tour-detail__kakao-map-button" src="/icons/btn_kakao_map.svg" alt="카카오맵" />
  //       </a>
  //       {/* <a href={`https://map.naver.com/v5/search/${data.fcltyNm}?c=/${data.longitude},${data.latitude}`} target="_blank" rel="noopener noreferrer">
  //         <img className="tour-detail__naver-map-button" src="/icons/btn_naver_map.svg" alt="네이버맵" />
  //       </a> */}
  //     </div>
  //   </>
  // );

  useEffect(() => {
    if (selectedTourData && selectedTourData.artist_id) {
      console.log('Artist Record Data:', selectedTourData.artist_id);
      fetchArtistRecords(selectedTourData.artist_id);
    }
  }, [selectedTourData]);

  // const TourDetail = ({ data }) => {

  //   return (
  //     <>
  //     <div className="tour-detail__title-block">
  //       <div className="tour-detail__title-text">{data.tour_name}</div>
  //       <div className="tour-detail__title-tag">{data.tour_type}</div>
  //     </div>
      
  //     <div className="tour-detail__reservation-link" onClick={() => navigate(`/studio-detail/${data.id}`)}>
  //       예약 바로가기
  //     </div>

  //     {artistRecords.length > 0 && (
  //       <>
  //         <div className="tour-detail__info-text">작가노트 엿보기</div>
  //         <div className="tour-detail__artist-records">
  //           {artistRecords.map(record => (
  //             <img
  //               key={record.id}
  //               src={`${artlog_ip}:3541/${record.record_photo}`}
  //               alt={record.record_subject}
  //               className="tour-detail__artist-record-image"
  //             />
  //           ))}
  //         </div>
  //       </>
  //     )}

  //     <div className="tour-detail__info-text">정보</div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_address.svg" />
  //       <div className="tour-detail__detail-text">{data.tour_location || '-'}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_phone.svg" />
  //       <div className="tour-detail__detail-text">{formatPhoneNumber(data.tour_phone)}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
  //       <div className="tour-detail__detail-text">{formatOpenDays(data.tour_open_days)}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
  //       <div className="tour-detail__detail-text">{data.tour_open_time}-{data.tour_close_time}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_homepage.svg" />
  //       <div className="tour-detail__detail-text">{data.tour_website || '-'}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_introduce.svg" />
  //       <div className="tour-detail__detail-text">{data.tour_description || '-'}</div>
  //     </div>

  //     <div className="tour-detail__map-buttons">
  //       <a href={`https://map.kakao.com/link/map/${data.tour_name},${data.tour_location_lat},${data.tour_location_lng}`} target="_blank" rel="noopener noreferrer">
  //         <img className="tour-detail__kakao-map-button" src="/icons/btn_kakao_map.svg" alt="카카오맵" />
  //       </a>
  //       {/* <a href={`https://map.naver.com/v5/search/${data.tour_name}?c=/${data.tour_location_lng},${data.tour_location_lat}`} target="_blank" rel="noopener noreferrer">
  //         <img className="tour-detail__naver-map-button" src="/icons/btn_naver_map.svg" alt="네이버맵" />
  //       </a> */}
  //       </div>
  //     </>
  //   )
  // }

  // const PoiDetail = ({ data }) => (
  //   <>
  //     <div className="tour-detail__title-block">
  //       <div className="tour-detail__title-text">{data.tour_name || '-'}</div>
  //       <div className="tour-detail__title-tag">
  //         {data.tour_type === 'museum' ? '박물관' : 
  //          data.tour_type === 'gallery' ? '미술관' : 
  //          data.tour_type === 'atelier' ? '아틀리에' : 
  //          data.tour_type === 'studio' ? '스튜디오' : 
  //          data.tour_type === 'residency' ? '레지던시' : '아틀리에'}
  //       </div>
  //     </div>

  //     <div className="tour-detail__info-text">정보</div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_address.svg" />
  //       <div className="tour-detail__detail-text">{data.tour_location || '-'}</div>
  //     </div>

  //     <div className="tour-detail__detail-block">
  //       <img className="tour-detail__detail-icon" src="icons/icon_phone.svg" />
  //       <div className="tour-detail__detail-text">{formatPhoneNumber(data.tour_phone)}</div>
  //     </div>

  //     {data.tour_open_days && (
  //       <div className="tour-detail__detail-block">
  //         <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
  //         <div className="tour-detail__detail-text">{formatOpenDays(data.tour_open_days)}</div>
  //       </div>
  //     )}

  //     {data.tour_open_time && (
  //       <div className="tour-detail__detail-block">
  //         <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
  //         <div className="tour-detail__detail-text">{data.tour_open_time}</div>
  //       </div>
  //     )}

  //     {data.tour_website && (
  //       <div className="tour-detail__detail-block">
  //         <img className="tour-detail__detail-icon" src="icons/icon_homepage.svg" />
  //         <div className="tour-detail__detail-text">{data.tour_website}</div>
  //       </div>
  //     )}

  //     {data.tour_description && (
  //       <div className="tour-detail__detail-block">
  //         <img className="tour-detail__detail-icon" src="icons/icon_introduce.svg" />
  //         <div className="tour-detail__detail-text">{data.tour_description}</div>
  //       </div>
  //     )}

  //     <div className="tour-detail__map-buttons">
  //       <a href={`https://map.kakao.com/link/map/${data.tour_name},${data.tour_location_lat},${data.tour_location_lng}`} target="_blank" rel="noopener noreferrer">
  //         <img className="tour-detail__kakao-map-button" src="/icons/btn_kakao_map.svg" alt="카카오맵" />
  //       </a>
  //       {/* <a href={`https://map.naver.com/v5/search/${data.tour_name}?c=/${data.tour_location_lng},${data.tour_location_lat}`} target="_blank" rel="noopener noreferrer">
  //         <img className="tour-detail__naver-map-button" src="/icons/btn_naver_map.svg" alt="네이버맵" />
  //       </a> */}
  //     </div>
  //   </>
  // );

  return (
    <div className="tour-main">
      {/* <div className="top-menu">
        <img className="top-menu__logo-image" src="icons/yournest_horizontal_logo.svg" onClick={gotoMain}/>
        <div className="top-menu__search-area">
          <input 
            className="top-menu__search-text" 
            placeholder="오늘은 어디를 가볼까요?"
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && navigate(`/studio-tour?search=${encodeURIComponent(searchKeyword)}`)}
          />
          <img 
            className="top-menu__search-icon" 
            src="icons/btn_search.svg" 
            alt="search icon" 
            onClick={() => navigate(`/studio-tour?search=${encodeURIComponent(searchKeyword)}`)}
          />
        </div>
        
        {!isAuthenticated ? (
          <div className="top-menu__user-area">
            <div className="top-menu__tour-link" onClick={() => window.open('https://litt.ly/atelier_tour', '_blank')} >
              아틀리에 투어 예약
            </div>
            <div className="top-menu__user-login" onClick={() => navigate('/login')} >로그인</div>
          </div>
        ) : userType === 'user' ? (
          <div className="top-menu__user-area">
            <div className="top-menu__tour-link" onClick={() => window.open('https://litt.ly/atelier_tour', '_blank')} >
            아틀리에 투어 예약
            </div>
            <div className="top-menu__user-mypage" onClick={() => navigate('/customer-mypage')} >마이페이지</div>
            <div className="top-menu__user-logout" onClick={handleLogout} >로그아웃</div>
          </div>
        ) : (
          <div className="top-menu__user-area">
            <div className="top-menu__artist-studio" onClick={() => navigate('/artist-studio')} >내 아틀리에</div>
            <div className="top-menu__artist-mypage" onClick={() => navigate('/artist-mypage')} >마이페이지</div>
            <div className="top-menu__user-logout" onClick={handleLogout} >로그아웃</div>
          </div>
        )}
      </div> */}
      <TopMenu 
        isAuthenticated={isAuthenticated}
        userType={userType}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        handleLogout={handleLogout}
      />
      <TourContainer
        showPreview={showPreview}
        handleImageClick={handleImageClick}
        moveToUserPosition={moveToUserPosition}
        selectedMuseumData={selectedMuseumData}
        selectedTourData={selectedTourData}
        selectedPoiData={selectedPoiData}
        artistRecords={artistRecords}
      />
      <TourFooter />
    </div>
  );
};
